import React from 'react'

export type BadgeVariant = 'brand' | 'neutral' | 'success' | 'warning' | 'error' | 'info'
export type BadgeSize = 'sm' | 'md'

export interface BadgeProps {
  variant?: BadgeVariant
  size?: BadgeSize
  dot?: boolean
  children: React.ReactNode
}

const variantClasses: Record<BadgeVariant, string> = {
  brand: 'bg-brand-100 text-brand-700',
  neutral: 'bg-neutral-100 text-neutral-700',
  success: 'bg-success-light text-success-dark',
  warning: 'bg-warning-light text-warning-dark',
  error: 'bg-error-light text-error-dark',
  info: 'bg-info-light text-info-dark',
}

const dotColorClasses: Record<BadgeVariant, string> = {
  brand: 'bg-brand-500',
  neutral: 'bg-neutral-500',
  success: 'bg-success-base',
  warning: 'bg-warning-base',
  error: 'bg-error-base',
  info: 'bg-info-base',
}

const sizeClasses: Record<BadgeSize, string> = {
  sm: 'px-2 py-1 text-xs rounded-full font-medium',
  md: 'px-3 py-1 text-sm rounded-full font-medium',
}

export function Badge({
  variant = 'neutral',
  size = 'md',
  dot = false,
  children,
}: BadgeProps): React.ReactElement {
  return (
    <span
      className={[
        'inline-flex items-center font-sans',
        variantClasses[variant],
        sizeClasses[size],
      ].join(' ')}
    >
      {dot && (
        <span
          aria-hidden="true"
          className={['w-2 h-2 rounded-full me-1 shrink-0', dotColorClasses[variant]].join(' ')}
        />
      )}
      {children}
    </span>
  )
}
